import dayjs from 'dayjs';
import { BusinessModuleRef } from './serializable/business-module-ref.js';
import { PhotoReference } from './serializable/file-reference/photo-reference.js';
import { DataModel } from './dto/data-model.js';

export abstract class Review extends DataModel {
  abstract get uniqueId(): string;
  abstract get creationDate(): dayjs.Dayjs;
  abstract get businessRef(): BusinessModuleRef;
  abstract get reviewText(): string;
  abstract get reviewRating(): number;
  abstract get reviewerId(): string;
  abstract get reviewerFirstName(): string;
  abstract get reviewerLastName(): string;
  abstract get reviewerFormattedName(): string;
  abstract get reviewerInitials(): string;
  abstract get isAnonymous(): boolean;
  abstract get reviewerPhoto(): PhotoReference | null;

  get businessId(): string {
    return this.businessRef.uniqueId;
  }

  get hasText(): boolean {
    return this.reviewText.length > 0;
  }
}
